var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_716_12819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.51 15.3802C19.28 15.3802 18.09 15.1802 16.98 14.8202C16.63 14.7002 16.24 14.7902 15.97 15.0602L14.4 17.0302C11.57 15.6802 8.92 13.1302 7.51 10.2002L9.46 8.54024C9.73 8.26024 9.81 7.87024 9.7 7.52024C9.33 6.41024 9.14 5.22024 9.14 3.99024C9.14 3.45024 8.69 3.00024 8.15 3.00024H4.69C4.15 3.00024 3.5 3.24024 3.5 3.99024C3.5 13.2802 11.23 21.0002 20.51 21.0002C21.22 21.0002 21.5 20.3702 21.5 19.8202V16.3702C21.5 15.8302 21.05 15.3802 20.51 15.3802Z",
    fill: "#AAA2C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_716_12819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.5a17548e87425d8b697702c00807377e.svg";
export { ForwardRef as ReactComponent };